const { REACT_APP_API_ENV } = process.env

export const URLS = {
  production: 'https://ms-docusign.provi.com.br',
  // staging: 'http://localhost:5000'
  staging: 'https://ms-docusign-staging.provi.com.br'
}

export const ROOT_URL = URLS[REACT_APP_API_ENV] || URLS['staging']
